<template>
  <v-popover
    trigger="hover focus"
    placement="right"
    :offset="8"
    :auto-hide="false"
    :popover-class="design === 'new' ? 'tooltip--management-guidance tooltip--new' : 'tooltip--management-guidance'"
    popover-inner-class="tooltip-inner popover-inner management-guidance-popover-inner"
  >
    <span
      class="management-guidance-icon"
      :class="[`management-guidance-icon--${tone}`, `management-guidance-icon--${design}`]"
      role="img"
      tabindex="0"
      :aria-label="tooltipText"
      @click.stop
    >
      <svg viewBox="0 0 24 24" width="19" height="19" fill="none" aria-hidden="true">
        <path d="M6 3.5h9l3 3V20H6a2 2 0 0 1-2-2V5.5a2 2 0 0 1 2-2Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
        <path d="M8 10h7M8 13.5h7M8 17h5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      </svg>
    </span>
    <template #popover><div class="management-guidance-popover-text">{{ tooltipText }}</div></template>
  </v-popover>
</template>

<script>
export default {
  name: 'LeadManagementGuidanceIcon',
  props: {
    status: { type: String, default: 'pending' },
    comment: { type: String, default: '' },
    design: { type: String, default: 'new', validator: value => ['legacy', 'new'].includes(value) }
  },
  computed: {
    tone() {
      return ['commented', 'not_required'].includes(this.status) ? this.status : 'pending'
    },
    label() {
      return {
        pending: 'Management comment pending',
        commented: 'Management comment available',
        not_required: 'Management comment not needed'
      }[this.tone]
    },
    tooltipText() {
      return this.tone === 'commented' && this.comment.trim() ? this.comment : this.label
    }
  }
}
</script>

<style scoped>
.management-guidance-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  color: #929b9e;
}
.management-guidance-icon--commented { color: #147a55; }
.management-guidance-icon--not_required { color: #c53b4b; }
.management-guidance-icon--legacy.management-guidance-icon--commented { color: #77b017; }
.management-guidance-icon--legacy.management-guidance-icon--not_required { color: #dd4e4e; }
</style>

<style>
.tooltip.tooltip--management-guidance .tooltip-inner.management-guidance-popover-inner {
  box-sizing: border-box;
  width: max-content;
  max-width: min(560px, calc(100vw - 24px));
  max-height: min(60vh, 480px);
  overflow: auto;
  line-height: 1.45;
}
.management-guidance-popover-text {
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}
</style>
